import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

const ReviewNoteDialog = ({
  open,
  title,
  label = 'Review note',
  initialValue = '',
  confirmLabel = 'Save',
  onClose,
  onConfirm,
}) => {
  const [value, setValue] = useState(initialValue || '');

  useEffect(() => {
    if (open) setValue(initialValue || '');
  }, [initialValue, open]);

  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          fullWidth
          multiline
          minRows={3}
          label={label}
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onConfirm?.(value)}>{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewNoteDialog;
